const validacionDePrecio = (precio) => {
    if (Number.isInteger(precio)) {
        return precio;
    } else {
        return precio?.toFixed(2);
    }
};

export {validacionDePrecio};